import React from 'react';
import { brandData, heroImages } from '../../data/mock';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToMembership = () => {
    document.getElementById('membership')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background - Mist color base with subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#E8EFEC] via-[#E8EFEC] to-[#dce5e1]" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-[#3E6259]/8 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-[#5C7A6E]/8 rounded-full blur-3xl" />

      <div className="container-custom relative z-10 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <div className="animate-fade-in-up">
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-normal text-[#1E2E2A] leading-[1.15] mb-6 tracking-wider">
                {brandData.title}
              </h1>
              <h2 className="text-xl md:text-2xl text-[#1E2E2A]/70 leading-relaxed mb-4">
                {brandData.supportingLine}
              </h2>
              <p className="text-sm text-[#5C7A6E] tracking-widest uppercase mb-10">
                {brandData.qualifierLine}
              </p>
            </div>

            <div className="animate-fade-in-up animation-delay-200">
              <Button
                size="lg"
                onClick={scrollToMembership}
                className="bg-[#3E6259] hover:bg-[#5C7A6E] text-white font-medium px-8 py-6 rounded-full text-base transition-all duration-300 hover:shadow-xl hover:shadow-[#3E6259]/20 group tracking-wide"
              >
                By Invitation Only
                <ArrowRight className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative animate-fade-in animation-delay-200">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl shadow-[#1E2E2A]/10">
              <img
                src={heroImages.main}
                alt="ANCHOR"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E2E2A]/20 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
